export default __webpack_public_path__ + "static/media/incoming-success.8eb520ac.svg";